import { Modal, Typography } from 'antd'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { router, usePage } from '@inertiajs/react'
import useZiggy from '@/hooks/useZiggy'
import IconWelcome from '@assets/icon/welcome.svg?react'

const OnBoardingModal = () => {
    const [open, setOpen] = useState(true)
    const { t } = useTranslation('popup')
    const { getRoute } = useZiggy()
    const { user } = usePage().props

    const handleOk = () => {
        router.post(getRoute('user.onboarding'))
        setOpen(false)
    }

    const handleCancel = () => {
        router.post(getRoute('user.onboarding'))
        setOpen(false)
    }

    const List = useMemo(
        () => [
            { word: 'firstWord', row: 'firstRow' },
            { word: 'secondWord', row: 'secondRow' },
            { word: 'thirdWord', row: 'thirdRow' },
            { word: 'fourthWord', row: 'fourthRow' },
            { word: 'fifthWord', row: 'fifthRow' },
            { word: 'sixthWord', row: 'sixthRow' },
        ],
        []
    )

    if (user?.is_onboarded || !user?.current_gcu_accepted) {
        return null
    }

    return (
        <>
            <Modal
                open={open}
                onOk={handleOk}
                closable={false}
                okText={t('popup:onboarding.okText')}
                cancelText={t('popup:onboarding.cancelText')}
                onCancel={handleCancel}
                css={(theme) => ({
                    top: 150,
                    '&.ant-modal .ant-modal-footer': {
                        textAlign: 'center',
                        paddingTop: 40,
                        paddingBottom: 20,
                        'button.ant-btn': {
                            fontSize: '16px',
                            height: '50px',
                            padding: '12px 15px',
                            borderRadius: '999px',
                            paddingInlineStart: '24px',
                            paddingInlineEnd: '24px',
                        },
                    },
                    '&.ant-modal .ant-modal-content': {
                        backgroundColor: 'transparent',
                        boxShadow: 'unset',
                        paddingLeft: 60,
                        paddingRight: 60,
                    },
                    '&.ant-modal .ant-modal-header': { backgroundColor: 'transparent' },
                    borderRadius: '10px',
                    width: '90% !important',
                    maxWidth: 940,
                    backgroundColor: theme.colors.form.main,
                })}
                title={
                    <>
                        <div
                            css={(theme) => ({
                                width: 112,
                                height: 112,
                                borderRadius: 27,
                                backgroundColor: theme.colors.disabled.contrastText,
                                margin: '0 auto 0px auto',
                                transform: 'translateY(-50px)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                '& > svg': {
                                    height: 74,
                                    color: theme.colors.accent.lightPeriwinkle,
                                },
                            })}
                        >
                            <IconWelcome />
                        </div>
                        <Typography.Title
                            css={() => ({
                                textAlign: 'center',
                                fontSize: '39px !important',
                                marginTop: '-30px !important',
                                marginBottom: '15px !important',
                                textTransform: 'capitalize',
                                color: 'white !important',
                            })}
                        >
                            {t('popup:onboarding.title')}
                        </Typography.Title>
                        <Typography.Title
                            level={2}
                            css={{
                                textAlign: 'left',
                                fontSize: '25px !important',
                                marginTop: '0 !important',
                                color: 'white !important',
                            }}
                        >
                            {t('popup:onboarding.subtitle')}
                        </Typography.Title>
                    </>
                }
            >
                <Typography.Paragraph css={(theme) => ({ fontSize: '15px', color: theme.colors.header.contrastText })}>
                    {t('popup:onboarding.text.firstRow')}
                </Typography.Paragraph>
                <ul css={{ listStyle: 'none', paddingBottom: 0 }}>
                    {List.map((item, index) => (
                        <li
                            css={(theme) => ({
                                paddingLeft: '1em',
                                textIndent: '-1em',
                                color: theme.colors.header.contrastText,
                                '&:before': {
                                    content: '" + "',
                                    paddingRight: '13px',
                                    fontWeight: 600,
                                    fontSize: '1.1rem',
                                    color: theme.colors.accent.palePurple,
                                },
                                marginBottom: '15px',
                                fontSize: '15px',
                            })}
                            key={`list-${index}`}
                        >
                            <Typography.Text
                                css={(theme) => ({ color: theme.colors.accent.palePurple, fontWeight: 600 })}
                            >
                                {t(`popup:onboarding.list.${item.word}`)}
                            </Typography.Text>
                            <Typography.Text
                                css={(theme) => ({
                                    color: theme.colors.header.contrastText,
                                })}
                            >
                                {t(`popup:onboarding.list.${item.row}`)}
                            </Typography.Text>
                        </li>
                    ))}
                </ul>
            </Modal>
        </>
    )
}

export default OnBoardingModal
